// src/hooks/useFetchMeals.js
import { useState, useEffect, useCallback } from "react";
import { api } from "../api";

export default function useFetchMeals() {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const loadMeals = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getMeals();
      setMeals(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMeals();
  }, [loadMeals]);

  return { meals, loading, error, refetch: loadMeals };
}
